import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useGoogleMap } from '@react-google-maps/api';
import PropTypes from 'prop-types';

export default function CustomMapControl(
  { position = window.google.maps.ControlPosition.TOP_LEFT, children },
) {
  const map = useGoogleMap();
  const controlDiv = document.createElement('div');

  useEffect(() => {
    const controls = map.controls[position];
    const index = controls.length;
    controls.push(controlDiv);
    return () => {
      controls.removeAt(index);
    };
  });

  return createPortal(
    <div style={{ marginLeft: 16, marginTop: 16 }}>{children}</div>,
    controlDiv,
  );
}

CustomMapControl.contextTypes = {
  position: PropTypes.any,
  children: PropTypes.object,
};
